import { zs } from "../../../i18n/en";

export default {
    overviewInfo: {
        area: 22344,
        useArea: 15435,
        rentedArea: 14356,
        notRentedArea: 12345
    },
    regionLease: {
        'A区': {
            useArea: 1534,
            rentArea: 2478,
            rentedArea: 1244,
            notRentedArea: 1234
        },
        'B区': {
            useArea: 1234,
            rentArea: 1244,
            rentedArea: 1244,
            notRentedArea: 1234
        },
        'C区': {
            useArea: 1234,
            rentArea: 1244,
            rentedArea: 1244,
            notRentedArea: 1234
        }
    },
    enterprise: [
        {
            "name": "Hightopo",
            "bgVisible": true,
            "legalPerson": "Lin *",
            "peopleNumber": "150",
            "area": "2500 m³"
        },
        {
            "name": "Xiamen HT",
            "bgVisible": false,
            "legalPerson": "Lin *",
            "peopleNumber": "150",
            "area": "2500 m³"
        },
        {
            "name": "Shanghai HT",
            "bgVisible": true,
            "legalPerson": "Lin *",
            "peopleNumber": "150",
            "area": "2500 m³"
        },
        {
            "name": "Tianjin HT",
            "bgVisible": false,
            "legalPerson": "Li *",
            "peopleNumber": "150",
            "area": "2500 m³"
        },
        {
            "name": "Qingdao HT",
            "bgVisible": true,
            "legalPerson": "Yu *",
            "peopleNumber": "150",
            "area": "2500 m³"
        },
        {
            "name": "Dalian HT",
            "bgVisible": false,
            "legalPerson": "Bo *",
            "peopleNumber": "150",
            "area": "2500 m³"
        },
        {
            "name": "Chengdu HT",
            "bgVisible": true,
            "legalPerson": "Zheng *",
            "peopleNumber": "150",
            "area": "2500 m³"
        },
        {
            "name": "Beijing HT",
            "bgVisible": false,
            "legalPerson": "Lin *",
            "peopleNumber": "150",
            "area": "2500 m³"
        }
    ],
    leaseArea: {
        area: [3234, 2355, 1233],
        time: ['一月', '二月', '三月', '四月', '五月', '六月'],
        name: [zs.$zs_r2_n_name1, zs.$zs_r2_n_name2, zs.$zs_r2_n_name3],
        useArea: [50, 60, 60, 71, 65, 58],
        rentedArea: [120, 134, 156, 161, 144, 134],
        notRentedArea: [263, 254, 216, 181, 174, 154],
    },
    outputValue: {
        time: ['2016', '2017', '2018', '2019', '2020'],
        name: [zs.$zs_r3_n_name1, zs.$zs_r3_n_name2],
        outputValue: [2324, 3123, 4322, 5423, 6321],
        taxRevenue: [1324, 2345, 3212, 4023, 4908],
    },
    prices: {
        region: [1900, 1500, 1200],
        regionxAxis: ["Zone A", "Zone B", "Zone C"],
        name: [zs.$zs_r4_n_name1],
        A: {
            'A01': 2100,
            'A02': 2050,
            'A03': 1910,
            'A04': 1800,
            'A05': 1850,
            'A06': 1920
        },
        B: {
            'B01': 2100,
            'B02': 2050,
            'B03': 1910,
            'B04': 1800,
            'B05': 1850,
            'B06': 1920,
            'B07': 1800,
            'B08': 1850,
            'B09': 1920,
            'B10': 1850,
            'B11': 1920
        },
        C: {
            'C01': 2100,
            'C02': 2050,
            'C03': 1910,
            'C04': 1800,
            'C05': 1850,
            'C06': 1920,
            'C07': 1910,
            'C08': 1800,
        }
    }
};